import { useIsMobile } from "../../hooks/useIsMobile";
import ContractMarkdown from "./ContractMarkdown";
import { bySummaryNum } from "./shared";

export default function AISummaryFlyout({ summaries, summaryType, title, projectName, onClose }) {
  const isMobile = useIsMobile();
  const sections = (summaries || [])
    .filter(s => s.SummaryType?.startsWith(summaryType + "_s"))
    .sort(bySummaryNum);

  const generatedAt = sections[0]?.GeneratedAt
    ? (() => {
        const raw = sections[0].GeneratedAt;
        const dt = new Date(raw.endsWith("Z") || raw.includes("+") ? raw : raw + "Z");
        return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
      })()
    : "";

  const allText = sections.map(s => {
    let text = s.SummaryText || "";
    // Old format: JSON wrapper { "title": "...", "markdown": "..." }
    const jsonStart = text.indexOf("{");
    if (jsonStart !== -1) {
      try {
        const parsed = JSON.parse(text.slice(jsonStart, text.lastIndexOf("}") + 1));
        if (parsed.markdown) text = parsed.markdown;
      } catch {}
    }
    // Unescape literal \n sequences stored in DB
    text = text.replace(/\\n/g, "\n");
    return text;
  }).join("\n\n");

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)", zIndex: 299 }} />
      <div style={{
        position: "fixed", top: 0, right: 0, width: isMobile ? "100%" : 620, height: "100vh",
        background: "#f8fafc", borderLeft: isMobile ? "none" : "1px solid var(--cs-border)",
        boxShadow: "-4px 0 32px rgba(0,0,0,0.12)", zIndex: 300,
        display: "flex", flexDirection: "column",
      }}>
        <div style={{ padding: isMobile ? "14px 16px" : "16px 22px", borderBottom: "1px solid var(--cs-border)", flexShrink: 0, background: "#0c4a6e" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>🤖 {title || "AI Contract Review"}</div>
              <div style={{ fontSize: 12, color: "#93c5fd", marginTop: 3 }}>{projectName}</div>
              {generatedAt && <div style={{ fontSize: 11, color: "#bae6fd", marginTop: 2 }}>Generated {generatedAt}</div>}
            </div>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", cursor: "pointer", fontSize: 18, color: "#fff", lineHeight: 1, padding: "4px 8px", borderRadius: 6 }}>✕</button>
          </div>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>
          {sections.length === 0 ? (
            <div style={{ color: "var(--text3)", fontSize: 13, textAlign: "center", marginTop: 40 }}>No AI summary available yet.</div>
          ) : (
            <ContractMarkdown text={allText} />
          )}
        </div>
      </div>
    </>
  );
}
